export let FlexBoxDirection = /*#__PURE__*/function (FlexBoxDirection) {
  FlexBoxDirection["Column"] = "Column";
  FlexBoxDirection["ColumnReverse"] = "ColumnReverse";
  FlexBoxDirection["Row"] = "Row";
  FlexBoxDirection["RowReverse"] = "RowReverse";
  return FlexBoxDirection;
}({});